import React, { Fragment } from "react";
import styled from "styled-components";
import media from "utils/media-queries";
import DataWrapChart from "../components/datawrap";
import { Grid } from "theme-ui";
import { Embed } from "theme-ui";

const Container = styled.div`
  max-width: 700px;
  min-width: 600px;
  margin-left: auto;
  margin-right: auto;
  min-height: 650px;
  ${media.lg`
    max-width: 600px;
  `}
  ${media.sm`
  min-width: 350px;
  margin-left: auto;
  margin-right: auto;
`}
`;

function SmallMultiples() {
  return (
    <Fragment>
      <h2> Overall Trends </h2>
      <p> A high-level overview of key trends presented in this dashboard.</p>
      <DataWrapChart
        title="OVerall Chart"
        frameborder="0"
        aria-label="Column Chart"
        id="datawrapper-chart-FxQJZ"
        min-width="400"
        min-height="550"
        allowfullscreen="true"
        src="https://datawrapper.dwcdn.net/lPVCk/
"
      />
    </Fragment>
  );
}

export default SmallMultiples;
